import React, { FC } from 'react';
import { AdfoxContextData, AdfoxContextProvider } from '../../context/AdfoxContext';
import { PParams } from '../../../types';
import { AdfoxBannerContainer } from '../../../AdfoxBannerContainer';

const POST_VIEW_ANALYTICS_DATA: AdfoxContextData['postViewAnalyticsData'] = {
  place: 'article',
  place__DEPRECATED: 'journal',
  name__DEPRECATED: 'Journal_maipage_article',
};

const P_PARAMS: PParams = { p1: 'ddcgx', p2: 'fkhj' };

const SIZE: AdfoxContextData['size'] = { height: 279, width: '100%' };

export const AdfoxBannerMainPageArticleMobile: FC = () => {
  return (
    <AdfoxContextProvider
      postViewAnalyticsData={POST_VIEW_ANALYTICS_DATA}
      place="mainPageArticle"
      size={SIZE}
      pParams={P_PARAMS}
    >
      {() => <AdfoxBannerContainer />}
    </AdfoxContextProvider>
  );
};
